import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import AttachmentModel from '@/views/Attachment/model/attachment'

@Component({
    inheritAttrs: false,
    name: 'attachment-dialog',
    components: { DialogTemplate },
})
export default class AttachmentDialog extends Mixins<MixinInterface>() {
    @Prop() props!: any

    screenHeight = Math.round(screen.height * 0.8)

    get attachment() {
        return this.props.attachment
    }

    get add() {
        return this.props.functions ? this.props.functions.add : null
    }

    loadingDelete = false
    async deleteAttachment() {
        if (this.attachment.canDelete) {
            this.loadingDelete = true
            await this.attachment?.delete()
            this.$emit('close', { delete: true, attachment: this.attachment })
            this.loadingDelete = false
        }
    }

    addAttachment() {
        this.$emit('close', { add: true, attachment: this.attachment })
    }

    error = false
    errorLoading() {
        this.error = true
    }
}
